"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../components/SvgIcon"));
var _SvgIconsMap = _interopRequireDefault(require("../components/SvgIconsMap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var createIcon = function createIcon(icon, size) {
  return typeof icon === "string" && Object.keys(_SvgIconsMap.default).includes(icon) ? /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: icon,
    size: size
  }) : icon;
};
var _default = exports.default = createIcon;